import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { Response } from '../models/response';
import { environment } from 'src/environments/environment';
import { HttpContextConfig } from '../models/http-context-config';
import { CONFIG } from '../interceptors/loader.interceptor';

const usersURL = `${environment.api}/users`;
const imgURL = `${environment.api}/img`;
@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  public profileLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public userLogged: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient) {}

  image: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  getImg(): any {
    return this.image.asObservable();
  }

  setImg(user: any) {
    this.image.next(user?.filestorage?.path ?? null);
  }

  async isAdmin(): Promise<boolean> {
    const user = await this.getLoggedUser();
    return user?.roles[0].name == 'admin';
  }

  async getLoggedRoleName(): Promise<string> {
    const user = await this.getLoggedUser();
    return user?.roles[0].name ?? '';
  }

  async getLoggedUser(): Promise<any> {
    if (!!this.userLogged.value == false) {
      await this.reloadProfile();
    }
    return this.userLogged.value;
  }

  async reloadProfile() {
    const res = await firstValueFrom(this.getProfile());
    this.userLogged.next(res.result);
    this.profileLoaded.next(true);
    this.setImg(this.userLogged.value);
  }

  getProfile(): Observable<any> {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);

    return this.http.get<any>(usersURL + '/profile', {
      context, // Mantieni il contesto esistente
      withCredentials: true // Aggiungi withCredentials
    });
  }

  getUserRoleAsync(): Promise<any> {
    return new Promise(resolve => {
      this.userLogged.subscribe(res => {
        if (res) {
          resolve(res);
        }
      });
    });
  }

  isProfileLoaded(): Observable<boolean> {
    return this.profileLoaded.asObservable();
  }

  getOtherUserProfile(search_id: any) {
    return this.http.get<any>(usersURL + '/profileUser', {
      params: new HttpParams().set('search_id', search_id)
    });
  }

  getProfileData_filter(month: any): Observable<Response<any>> {
    return this.http.get<Response<any>>(usersURL + '/manage', {
      params: new HttpParams().set('month', month)
    });
  }

  getTeamembersData() {
    return this.http.get<any>(usersURL + '/teamembers');
  }

  saveProfilePic(file_img: any, id: string): Observable<Response<any>> {
    return this.http.post<Response<any>>(imgURL + `/${id}/picture`, file_img);
  }

  profileUser(search_id: any): Observable<Response<any>> {
    return this.http.get<any>(usersURL + `/profileUser/`, {
      params: new HttpParams().set('search_id', search_id)
    });
  }
}
